import { useState } from "react";
import Scholars from "./Scholars";
import Sidebar from './Sidebar';
import AddScholar from "./AddScholar";
export default function HomeWrapper() {

    const [topMmr, setTopMmr] = useState([]);
    const [sortedTopMmr, setSortedTopMmr] = useState([]);
    
    function handleScholars(currentScholar) {
        if(currentScholar.mmr !== undefined){
            setTopMmr([...topMmr, currentScholar]);
            const sorted = [...topMmr].sort((a, b) => {
                if (a.mmr > b.mmr) return -1;
                if (a.mmr < b.mmr) return 1;
                return 0;
            });
            setSortedTopMmr(sorted);
        }
    }
    return (
    <div>
        <AddScholar />
        <div className="home__wrapper">
            <Scholars sendToHome={handleScholars}/>
            {/* <Sidebar /> */}
            <Sidebar sortedTopMmr={sortedTopMmr}/>
        </div>
    </div>
    );
}
